import { createMemo } from 'react-use'
import { useModelStore } from '@editorStores'
import mapValueKey from '../utils/mapValueKey'

const mapGuidToElement = (model: PlanarModel) => {
  return {
    ...mapValueKey(model.walls),
    ...mapValueKey(model.beams),
    ...mapValueKey(model.columns),
    ...mapValueKey(model.purlins),
    ...mapValueKey(model.roof_slabs),
    ...mapValueKey(model.slabs),
    ...mapValueKey(model.vertical_roof_slabs),
    ...mapValueKey(model.vertical_slabs),
    ...mapValueKey(model.vertical_slabs.map(el => el.beam)),
    ...mapValueKey(model.vertical_roof_slabs.map(el => el.beam)),
  }
}

const useMapGuidToElement = createMemo(mapGuidToElement)

const useGuidToElement = (): Record<string, ShapeObject | ShapeObjectLine> => {
  const model = useModelStore(state => state.model)

  return useMapGuidToElement(model)
}

export default useGuidToElement
